
import { DeviceInfo } from '../types';

// Process device info to get platform category
export const getPlatformCategory = (deviceInfo: DeviceInfo | any): string => {
  // Handle cases where userAgent might be missing or the deviceInfo structure is different
  const userAgent = deviceInfo?.userAgent || deviceInfo?.user_agent || '';
  
  if (!userAgent) {
    // If no user agent available, try to use existing platform info or fallback
    if (deviceInfo?.platform) {
      return deviceInfo.platform;
    }
    return 'desktop'; // Default fallback
  }
  
  const ua = userAgent.toLowerCase();
  
  // Enhanced mobile detection patterns
  const mobilePatterns = [
    /iphone/i,
    /ipod/i, 
    /android.*mobile/i,
    /blackberry/i, 
    /iemobile/i, 
    /opera mini/i,
    /opera mobi/i,
    /mobile.*firefox/i
  ];
  
  // Enhanced tablet detection patterns
  const tabletPatterns = [
    /ipad/i,
    /android(?!.*mobile)/i,
    /tablet/i,
    /kindle/i,
    /silk/i,
    /tablet.*firefox/i
  ];
  
  // Check mobile patterns first
  for (const pattern of mobilePatterns) {
    if (pattern.test(ua)) return 'mobile';
  }
  
  // Check tablet patterns next
  for (const pattern of tabletPatterns) {
    if (pattern.test(ua)) return 'tablet';
  }
  
  // Fallback to screen dimension check if available
  const screenWidth = deviceInfo?.screenWidth || deviceInfo?.screen_width;
  const screenHeight = deviceInfo?.screenHeight || deviceInfo?.screen_height;
  
  if (screenWidth && screenHeight) {
    const minDimension = Math.min(screenWidth, screenHeight);
    const maxDimension = Math.max(screenWidth, screenHeight);
    
    if (minDimension < 600) {
      return 'mobile';
    } else if (minDimension < 1024 && maxDimension < 1366) {
      return 'tablet';
    }
  }
  
  return 'desktop';
};

export const detectPlatform = (): string => {
  const userAgent = navigator.userAgent || 'unknown';
  
  // Enhanced mobile detection patterns
  const mobilePatterns = [
    /iphone/i,
    /ipod/i, 
    /android.*mobile/i,
    /blackberry/i, 
    /iemobile/i, 
    /opera mini/i,
    /opera mobi/i,
    /mobile.*firefox/i
  ];
  
  // Enhanced tablet detection patterns
  const tabletPatterns = [
    /ipad/i,
    /android(?!.*mobile)/i,
    /tablet/i,
    /kindle/i,
    /silk/i,
    /tablet.*firefox/i
  ];
  
  // Check mobile patterns first
  for (const pattern of mobilePatterns) {
    if (pattern.test(userAgent)) return 'mobile';
  }
  
  // Check tablet patterns next
  for (const pattern of tabletPatterns) {
    if (pattern.test(userAgent)) return 'tablet';
  }
  
  // Fallback to screen dimension check if available
  if (typeof window !== 'undefined' && window.screen) {
    const minDimension = Math.min(window.screen.width, window.screen.height);
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    
    if (minDimension < 600) {
      return 'mobile';
    } else if (minDimension < 1024 && maxDimension < 1366) {
      return 'tablet';
    }
  }
  
  return 'desktop';
};
